/*
 * @Description: 分账设置
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2023-08-08 16:58:25
 * @LastEditTime: 2023-08-20 15:18:12
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 代理商帐户详情
  adminAdapay (querys) {
    return get('adapay/admin/AdminMember/adminAdapay', querys)
  },
  // 分账账户
  memberList (querys) {
    return get('adapay/admin/AdminMember/memberList', querys)
  },
  // 分账账户详情
  memberInfo (querys) {
    return get('adapay/admin/AdminMember/memberInfo', querys)
  },
  // 新增分账账户
  memberAdd (querys) {
    return post('adapay/admin/AdminMember/memberAdd', querys)
  },
  // 编辑分账账户
  memberUpdate (querys) {
    return post('adapay/admin/AdminMember/memberUpdate', querys)
  },
  // 删除分账账户
  memberStatusUpdate (querys) {
    return post('adapay/admin/AdminMember/memberStatusUpdate', querys)
  },
  // 账户余额
  adminInfo (querys) {
    return get('adapay/admin/AdminMember/adminInfo', querys)
  },
  // 账户充值
  adminPay (querys) {
    return post('adapay/admin/AdminMember/adminPay', querys)
  },
  // 支付成功回调
  checkAdminPay (querys) {
    return get('adapay/admin/AdminMember/checkAdminPay', querys)
  },
  // 分账设置
  configInfo (querys) {
    return get('adapay/admin/AdminMember/configInfo', querys)
  },
  // 编辑分账设置
  configUpdate (querys) {
    return post('adapay/admin/AdminMember/configUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/adapay.js